enum ION_VARIANT {
    PRIMARY = 'purple',
    SECONDARY = 'blue',
    SUCCESS = 'success',
    DANGER = 'danger',
    LIGHT = 'light',
    MEDIUM = 'sand',
    PURPLE = 'purple',
    CORAL = 'coral',
    BLUE = 'blue',
    SAND = 'sand',
    GREY_1 = 'grey1',
    GREY_2 = 'grey2',
    GREY_3 = 'grey3',
    GREY_4 = 'grey4',
    GRADIENT = 'gradient',
    OCTO_GRADIENT = 'octo-gradient',
    TRANSPARENT = 'transparent',
    WARNING = 'warning',
    PINK = 'pink'
}

enum ION_MODE {
    IOS = 'ios',
    MD = 'md'
}

enum ION_SIZE {
    DEFAULT = 'default',
    LARGE = 'large',
    SMALL = 'small'
}

enum POPOVER_SIZE {
    SMALL = 'sm',
    MEDIUM = 'md',
    LARGE = 'lg',
    X_LARGE = 'xl',
}

enum ION_ROUTER_DIRECTION {
    BACK = 'back',
    FORWARD = 'forward',
    ROOT = 'root'
}

enum ION_WRAP_MODE {
    HARD = 'hard',
    OFF = 'off',
    SOFT = 'soft'
}

enum ION_ALIGNMENT {
    CENTER = 'center',
    END = 'end',
    START = 'start'
}

enum ION_REFERENCE {
    EVENT = 'event',
    TRIGGER = 'trigger'
}

enum ION_SIDE {
    BOTTOM = 'bottom',
    END = 'end',
    LEFT = 'left',
    RIGHT = 'right',
    START = 'start',
    TOP = 'top'
}

enum ION_POPOVER_SIZE {
    AUTO = 'auto',
    COVER = 'cover'
}

enum ION_TRIGGER_ACTION {
    CLICK = 'click',
    CONTEXT_MENU = 'context-menu',
    HOVER = 'hover'
}

enum ION_TOAST_POSITION {
    TOP = 'top',
    MIDDLE = 'middle',
    BOTTOM = 'bottom'
}

enum BUTTON_EXPAND {
    BLOCK = 'block',
    FULL = 'full'
}

enum BUTTON_FILL {
    CLEAR = 'clear',
    DEFAULT = 'default',
    OUTLINE = 'outline',
    SOLID = 'solid'
}

enum BUTTON_TYPE {
    BUTTON = 'button',
    RESET = 'reset',
    SUBMIT = 'submit'
}

enum LINK_TARGET {
    BLANK = '_blank',
    SELF = '_self',
    PARENT = '_parent',
    TOP = '_top'
}

enum AUTO_CAPITALIZE_MODE {
    OFF = 'off',
    NONE = 'none',
    ON = 'on',
    SENTENCES = 'sentences',
    WORDS = 'words',
    CHARACTERS = 'characters'
}

enum AUTO_COMPLETE_FIELD {
    OFF = "off",
    ON = "on",
    NAME = "name",
    HONOR_PREFIX = "honorific-prefix",
    GIVEN_NAME = "given-name",
    ADDITIONAL_NAME = "additional-name",
    FAM_NAME = "family-name",
    HONOR_SUFFIX = "honorific-suffix",
    NICKNAME = "nickname",
    EMAIL = "email",
    USERNAME = "username",
    NEW_PW = "new-password",
    CURRENT_PW = "current-password",
    OTC = "one-time-code",
    ORGANIZATION_TITLE = "organization-title",
    ORGANIZATION = "organization",
    STREET_ADDRESS = "street-address",
    ADDRESS_LINE1 = "address-line1",
    ADDRESS_LINE2 = "address-line2",
    ADDRESS_LINE3 = "address-line3",
    ADDRESS_LINE4 = "address-level4",
    ADDRESS_LVL3 = "address-level3",
    ADDRESS_LVL2 = "address-level2",
    ADDRESS_LVL1 = "address-level1",
    COUNTRY = "country",
    COUNTRY_NAME = "country-name",
    POSTAL = "postal-code",
    CC_NAME = "cc-name",
    CC_GIVEN_NAME = "cc-given-name",
    CC_ADDITIONAL_NAME = "cc-additional-name",
    CC_FAMILY_NAME = "cc-family-name",
    CC_NUMBER = "cc-number",
    CC_EXP = "cc-exp",
    CC_EXP_MONTH = "cc-exp-month",
    CC_EXP_YEAR = "cc-exp-year",
    CC_CSC = "cc-csc",
    CC_TYPE = "cc-type",
    TRANSACTION_CURRENCY = "transaction-currency",
    TRANSACTION_AMOUNT = "transaction-amount",
    LANGUAGE = "language",
    B_DATE = "bday",
    B_DAY = "bday-day",
    B_MONTH = "bday-month",
    B_YEAR = "bday-year",
    SEX = "sex",
    TEL = "tel",
    TEL_COUNTRY_COD = "tel-country-code",
    TEL_NATIONAL = "tel-national",
    TEL_AREA_CODE = "tel-area-code",
    TEL_LOCAL = "tel-local",
    TEL_EXTENSION = "tel-extension",
    IMPP = "impp",
    URL = "url",
    PHOTO = "photo"
}

enum ION_ENTER_HINT {
    ENTER = 'enter',
    DONE = 'done',
    GO = 'go',
    NEXT = 'next',
    PREVIOUS = 'previous',
    SEARCH = 'search',
    SEND = 'send'
}


enum INPUT_MODE {
    DECIMAL = 'decimal',
    EMAIL = 'email',
    NONE = 'none',
    NUMERIC = 'numeric',
    SEARCH = 'search',
    TEL = 'tel',
    TEXT = 'text',
    URL = 'url'
}

enum INPUT_TYPE {
    DATE = "date",
    DATE_TIME = "datetime-local",
    EMAIL = "email",
    MONTH = "month",
    NUMBER = "number",
    PASSWORD = "password",
    SEARCH = "search",
    TEL = "tel",
    TEXT = "text",
    TIME = "time",
    URL = "url",
    WEEK = "week"
}

enum ION_SELECT_INTERFACE {
    ACTION_SHEET = 'action-sheet',
    ALERT = 'alert',
    POPOVER = 'popover'
}

enum APP_LANGUAGES {
    DE = 'de',
    EL = 'el',
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    IT = 'it',
    NL = 'nl',
    RO = 'ro',
    TR = 'tr'
}

enum LABEL_POSITION {
    FIXED = 'fixed',
    FLOATING = 'floating',
    STACKED = 'stacked'
}

enum ION_EVENT_TYPE {
    CHANGE = 'v-ion-change',
    MODAL_WILL_DISMISS = 'ion-modal-will-dismiss'
}

export {
    BUTTON_TYPE,
    ION_VARIANT,
    BUTTON_EXPAND,
    BUTTON_FILL,
    ION_MODE,
    ION_ROUTER_DIRECTION,
    ION_SIZE,
    LINK_TARGET,
    AUTO_CAPITALIZE_MODE,
    AUTO_COMPLETE_FIELD,
    ION_ENTER_HINT,
    INPUT_MODE,
    INPUT_TYPE,
    APP_LANGUAGES,
    ION_WRAP_MODE,
    ION_SELECT_INTERFACE,
    ION_ALIGNMENT,
    ION_REFERENCE,
    ION_SIDE,
    ION_POPOVER_SIZE,
    ION_TRIGGER_ACTION,
    ION_TOAST_POSITION,
    POPOVER_SIZE,
    LABEL_POSITION,
    ION_EVENT_TYPE
}
